(function () {
  'use strict';

  var MOBILE_BREAKPOINT = '(max-width: 767px)';

  function FloatingAddToCart(container) {
    this.container = container;
    this.button = container.querySelector('[data-floating-atc-button]');
    this.label = container.querySelector('[data-floating-atc-label]');
    this.price = container.querySelector('[data-floating-atc-price]');
    this.sourceForm = document.getElementById(container.dataset.sourceFormId);
    this.sourceButton = this.sourceForm && this.sourceForm.querySelector('[data-add-to-cart]');
    this.sourceLabel = this.sourceButton && this.sourceButton.querySelector('.btn-state-ready');
    this.sourceAction = this.sourceLabel && this.sourceLabel.querySelector('[data-add-to-cart-text]');
    this.sourcePrice = this.sourceLabel && this.sourceLabel.querySelector('[data-button-price]');
    this.productSection = this.sourceForm && this.sourceForm.closest('[data-section-type="product"]');
    this.optionSelects = Array.prototype.slice.call(
      container.querySelectorAll('[data-floating-atc-option]')
    );
    this.quantityInput = container.querySelector('[data-floating-atc-quantity]');
    this.sizeGuideButtons = Array.prototype.slice.call(
      container.querySelectorAll('[data-floating-atc-size-guide]')
    );
    this.decreaseButton = container.querySelector('[data-floating-atc-decrease]');
    this.increaseButton = container.querySelector('[data-floating-atc-increase]');
    this.interactiveControls = Array.prototype.slice.call(
      container.querySelectorAll('button, select, input')
    );
    this.sourceQuantity = this.sourceForm && this.sourceForm.elements.namedItem('quantity');
    this.stickyHeader = document.querySelector(
      '[data-header-sticky="sticky"] [data-header-height]'
    );
    this.cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    this.mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    this.frameRequested = false;

    if (
      !this.button ||
      !this.price ||
      !this.sourceButton ||
      !this.sourceLabel ||
      !this.sourceAction ||
      !this.sourcePrice ||
      !this.productSection ||
      !this.quantityInput ||
      !this.decreaseButton ||
      !this.increaseButton
    ) {
      container.remove();
      return;
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.openSizeGuide = this.openSizeGuide.bind(this);
    this.decreaseQuantity = this.decreaseQuantity.bind(this);
    this.increaseQuantity = this.increaseQuantity.bind(this);
    this.scheduleUpdate = this.scheduleUpdate.bind(this);
    this.update = this.update.bind(this);

    this.button.addEventListener('click', this.handleClick);
    this.optionSelects.forEach(function (select) {
      select.addEventListener('change', this.handleOptionChange);
    }, this);
    this.quantityInput.addEventListener('change', this.handleQuantityChange);
    this.sizeGuideButtons.forEach(function (button) {
      button.addEventListener('click', this.openSizeGuide);
    }, this);
    this.decreaseButton.addEventListener('click', this.decreaseQuantity);
    this.increaseButton.addEventListener('click', this.increaseQuantity);

    if (this.sourceQuantity) {
      this.sourceQuantity.addEventListener('change', this.scheduleUpdate);
    }
    window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
    window.addEventListener('resize', this.scheduleUpdate, { passive: true });
    document.addEventListener('theme:variant:change', this.scheduleUpdate);
    document.addEventListener('theme:cart:change', this.scheduleUpdate);

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.scheduleUpdate);
    } else {
      this.mediaQuery.addListener(this.scheduleUpdate);
    }

    this.sourceObserver = new MutationObserver(this.scheduleUpdate);
    this.sourceObserver.observe(this.sourceButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    if (this.cartDrawer) {
      this.drawerObserver = new MutationObserver(this.scheduleUpdate);
      this.drawerObserver.observe(this.cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    container.dataset.floatingAtcInitialized = 'true';
    document.body.classList.add('floating-atc-enabled');
    this.update();
  }

  FloatingAddToCart.prototype.isDrawerOpen = function () {
    return Boolean(
      this.cartDrawer &&
      (this.cartDrawer.classList.contains('drawer--visible') ||
        this.cartDrawer.classList.contains('is-open'))
    );
  };

  FloatingAddToCart.prototype.syncButton = function () {
    var actionText = this.sourceAction.textContent.replace(/\s+/g, ' ').trim();

    this.label.textContent = actionText;
    this.price.textContent = this.sourcePrice.textContent.replace(/\s+/g, ' ').trim();
    this.button.disabled = this.sourceButton.disabled;
    this.button.setAttribute('aria-label', actionText);

    var isLoading = this.sourceButton.classList.contains('loading');
    this.button.classList.toggle('loading', isLoading);
    this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  FloatingAddToCart.prototype.syncControls = function () {
    this.optionSelects.forEach(function (select) {
      var position = select.dataset.optionPosition;
      var wrapper = this.productSection.querySelector(
        '[data-option-position="' + position + '"]'
      );

      if (!wrapper) return;

      var sourceOption =
        wrapper.querySelector('input[name^="options"]:checked') ||
        wrapper.querySelector('input[name^="options"]:not([type="radio"])');

      if (sourceOption && select.value !== sourceOption.value) {
        select.value = sourceOption.value;
      }
    }, this);

    if (this.sourceQuantity && this.quantityInput.value !== this.sourceQuantity.value) {
      this.quantityInput.value = this.sourceQuantity.value;
    }
  };

  FloatingAddToCart.prototype.syncHeight = function () {
    if (!this.mediaQuery.matches) return;

    var previewBar = document.getElementById('preview-bar-iframe');
    var previewOffset = 0;

    if (previewBar) {
      var previewPosition = previewBar.getBoundingClientRect();
      if (previewPosition.height > 0 && previewPosition.bottom >= window.innerHeight - 1) {
        previewOffset = previewPosition.height;
      }
    }

    document.documentElement.style.setProperty(
      '--floating-atc-height',
      this.container.offsetHeight + 'px'
    );
    document.documentElement.style.setProperty(
      '--floating-atc-preview-offset',
      previewOffset + 'px'
    );
  };

  FloatingAddToCart.prototype.update = function () {
    this.frameRequested = false;
    this.syncButton();
    this.syncControls();
    this.syncHeight();

    var sourcePosition = this.sourceButton.getBoundingClientRect();
    var visibleTop = this.stickyHeader
      ? Math.max(0, this.stickyHeader.getBoundingClientRect().bottom)
      : 0;
    var sourceButtonIsVisuallyGone = sourcePosition.bottom <= visibleTop;
    var shouldShow =
      this.mediaQuery.matches &&
      sourceButtonIsVisuallyGone &&
      !this.isDrawerOpen();

    this.container.classList.toggle('is-visible', shouldShow);
    this.container.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    this.interactiveControls.forEach(function (control) {
      control.tabIndex = shouldShow ? 0 : -1;
    });

    if ('inert' in this.container) {
      this.container.inert = !shouldShow;
    }
  };

  FloatingAddToCart.prototype.scheduleUpdate = function () {
    if (this.frameRequested) return;

    this.frameRequested = true;
    window.requestAnimationFrame(this.update);
  };

  FloatingAddToCart.prototype.handleClick = function () {
    if (this.sourceButton.disabled || this.sourceButton.classList.contains('loading')) return;

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.sourceButton.click();
    this.scheduleUpdate();
  };

  FloatingAddToCart.prototype.openSizeGuide = function () {
    var modal = document.getElementById('sizechart');

    if (!modal || typeof modal.showModal !== 'function') return;

    modal.showModal();
    document.body.style.overflow = 'hidden';
  };

  FloatingAddToCart.prototype.handleOptionChange = function (event) {
    var select = event.currentTarget;
    var wrapper = this.productSection.querySelector(
      '[data-option-position="' + select.dataset.optionPosition + '"]'
    );

    if (!wrapper) return;

    var sourceOptions = Array.prototype.slice.call(
      wrapper.querySelectorAll('input[name^="options"][type="radio"], [data-popout-option]')
    );
    var matchingOption = sourceOptions.find(function (option) {
      return (option.value || option.dataset.value) === select.value;
    });

    if (matchingOption) {
      matchingOption.click();
    } else {
      var hiddenOption = wrapper.querySelector('input[name^="options"]');
      if (hiddenOption) {
        hiddenOption.value = select.value;
        hiddenOption.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    this.scheduleUpdate();
  };

  FloatingAddToCart.prototype.setQuantity = function (value) {
    var quantity = Math.max(1, parseInt(value, 10) || 1);
    this.quantityInput.value = quantity;

    if (this.sourceQuantity) {
      this.sourceQuantity.value = quantity;
      this.sourceQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.scheduleUpdate();
  };

  FloatingAddToCart.prototype.handleQuantityChange = function (event) {
    this.setQuantity(event.currentTarget.value);
  };

  FloatingAddToCart.prototype.decreaseQuantity = function () {
    this.setQuantity((parseInt(this.quantityInput.value, 10) || 1) - 1);
  };

  FloatingAddToCart.prototype.increaseQuantity = function () {
    this.setQuantity((parseInt(this.quantityInput.value, 10) || 1) + 1);
  };

  function initFloatingAddToCart(scope) {
    var root = scope || document;
    var containers = root.querySelectorAll('[data-floating-atc]:not([data-floating-atc-initialized])');

    containers.forEach(function (container) {
      new FloatingAddToCart(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFloatingAddToCart(document);
    });
  } else {
    initFloatingAddToCart(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFloatingAddToCart(event.target);
  });
})();
